<template>
  <tr role="row" v-if="showRow">
    <td
      style="
        border-right: 2px solid #ecedf2;
        border-left: 2px solid #ecedf2;
        border-bottom: 2px solid #ecedf2;
      "
      class="kt-datatable sub-table"
      colspan="8"
    >
      <div
        :class="'datatable_' + field"
        class="
          kt-datatable
          kt-datatable--default
          kt-datatable--brand
          kt-datatable--scroll
          kt-datatable--loaded
        "
        style
      >
        <table
          class="kt-datatable__table sticky"
          style="display: block; max-height: 400px; overflow-x: scroll"
        >
          <thead class="kt-datatable__head">
            <tr class="kt-datatable__row">
              <th
                colspan="100"
                :key="field + '_th_' + column.key + index"
                v-for="column in tableColumns"
                :data-field="column.key"
                :style="column.key == 'addFavorite' ? 'width:25px;' : ''"
                class="kt-datatable__cell kt-datatable__cell--sort"
              >
                <span>{{ labels[column.title] }}</span>
              </th>
            </tr>
          </thead>
          <tbody class="kt-datatable__body ps" style="max-height: 346px">
            <template v-for="(data, dataIndex) in listData">
              <tr
                :key="field + '_row_' + dataIndex"
                class="kt-datatable__row"
                v-if="
                  dataIndex < page * limit && dataIndex >= page * limit - limit
                "
              >
                <td
                  colspan="100"
                  :key="field + '_td_' + column.key + index"
                  v-for="column in tableColumns"
                  :data-field="column.key"
                  class="kt-datatable__cell"
                >
                  <span v-if="column.key == 'previewLink'">
                    <router-link
                      :to="`/dashboard/manage-products/product/preview?productId=${data.productId}`"
                      class="
                        previewLink
                        btn btn-primary
                        m-btn
                        m-btn--icon
                        m-btn--icon-only
                        m-btn--custom
                        m-btn--pill
                      "
                    >
                      <i class="fa fa-binoculars"></i>
                    </router-link>
                  </span>
                  <span v-else-if="column.key == 'addFavorite'">
                    <button
                      v-on:click="addRoleToFavorite(data)"
                      :class="
                        isFavoriteRole(data) ? 'btn-primary' : 'btn-secondary'
                      "
                      class="
                        btn
                        m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill
                      "
                    >
                      <i class="fa fa-star"></i>
                    </button>
                  </span>

                  <span v-else>
                    <span v-html="showRowData(data, column.key)"></span>
                  </span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div
          class="dataTables_paginate paging_simple_numbers"
          v-if="canGoToPrev || canGoToNext"
        >
          <ul class="pagination">
            <li
              class="paginate_button page-item previous"
              :class="{ disabled: !canGoToPrev, active: canGoToPrev }"
            >
              <a
                href="#"
                style="border-radius: 3px"
                @click.prevent="page -= 1"
                aria-controls="kt_table_1"
                data-dt-idx="0"
                tabindex="0"
                class="page-link"
              >
                <i class="la la-angle-left"></i>
                {{ labels.previous }}
              </a>
            </li>
            <li
              class="paginate_button page-item next"
              :class="{ disabled: !canGoToNext, active: canGoToNext }"
            >
              <a
                href="#"
                style="border-radius: 3px"
                @click.prevent="nextPage"
                aria-controls="kt_table_1"
                data-dt-idx="3"
                tabindex="0"
                class="page-link"
              >
                {{ labels.next }}
                <i class="la la-angle-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState } from "vuex";
import { firestoreDB } from "../../../assets/js/firebase";

const firebase = require("firebase/app");

const verbatimData = [{ key: "name", title: "verbatims" }];
const productRoleData = [
  { key: "addFavorite", title: "title.roles_favorite" },
  { key: "roles", title: "roles" },
];
const patentRoleData = [
  { key: "addFavorite", title: "title.roles_favorite" },
  { key: "roles", title: "patentRoles" },
];
const productData = [
  { key: "brandName", title: "product" },
  { key: "collectionName", title: "collectionName" },
  { key: "name", title: "name" },
  { key: "previewLink", title: "previewLink" },
];
const productLeaderData = [
  { key: "brandName", title: "product_leader" },
  { key: "collectionName", title: "collectionName" },
  { key: "name", title: "name" },
  { key: "previewLink", title: "previewLink" },
];

export default {
  props: ["field", "data", "index"],
  data() {
    return {
      page: 1,
      limit: 5,
      segmentationFavoriteRoles: [],
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      crudData: (store) => store.crudData.cruds,
      sessionUser: (state) => state.sessionUser,
    }),
    productRolesList() {
      const roles = [];
      if (this.data.products.length) {
        this.data.products.forEach((product) => {
          if (product.hasOwnProperty("roles") && product.roles.length) {
            product.roles.forEach((role) => {
              roles.indexOf(role) === -1 ? roles.push(role) : null;
            });
          }
        });
      }
      return this.orderByFavorite(roles);
    },
    patentRolesList() {
      const roles = [];
      if (this.data.products.length) {
        this.data.products.forEach((product) => {
          if (product.hasOwnProperty("patentsV2") && product.patentsV2.length) {
            product.patentsV2.forEach((patent) => {
              if (patent.roles) {
                patent.roles.forEach((role) => {
                  roles.indexOf(role.name) === -1
                    ? roles.push(role.name)
                    : null;
                });
              }
            });
          }
        });
      }
      return this.orderByFavorite(roles);
    },
    productsList() {
      if (this.data.products.length) {
        return this.orderBy(this.data.products, "brandName");
      }
      return [];
    },
    verbatimConsosList() {
      if (this.data.verbatims) {
        return this.orderBy(this.data.verbatims);
      }
      return [];
    },
    productLeadersList() {
      if (this.data.productLeaders.length) {
        return this.orderBy(this.data.productLeaders, "brandName");
      }
      return [];
    },
    tableColumns() {
      switch (this.field) {
        case "products":
          return productData;
        case "productRoles":
          return productRoleData;
        case "patentRoles":
          return patentRoleData;
        case "verbatimConsos":
          return verbatimData;
        case "productLeaders":
          return productLeaderData;
      }
    },
    listData() {
      return this[`${this.field}List`];
    },
    canGoToNext() {
      return this.page < this.listData.length / this.limit;
    },
    canGoToPrev() {
      return this.page > 1;
    },
    showRow() {
      if (this.field === "productRoles") {
        return this.productRolesList.length;
      }
      if (this.field === "patentRoles") {
        return this.patentRolesList.length;
      }
      return true;
    },
  },
  methods: {
    showRowData(data, column) {
      if (this.field == "productRoles" && column == "roles") {
        return data;
      }
      if (this.field == "patentRoles" && column == "roles") {
        return data;
      }
      return typeof data === "string" ? data : data[column];
    },
    nextPage() {
      if (this.canGoToNext) {
        this.page += 1;
      }
    },
    prevPage() {
      if (this.canGoToPrev) {
        this.page -= 1;
      }
    },
    orderBy(dataArray, orderByKey) {
      return dataArray.sort((a, b) => {
        const posA = orderByKey ? a[orderByKey] : a;
        const posB = orderByKey ? b[orderByKey] : b;
        return posA.localeCompare(posB, "fr", { sensitivity: "base" });
      });
    },
    orderByFavorite(dataArray) {
      return dataArray.sort((a, b) => {
        const Afavorite = this.isFavoriteRole(a);
        const Bfavorite = this.isFavoriteRole(b);

        if (Afavorite == Bfavorite) {
          const posA = a;
          const posB = b;
          return posA.localeCompare(posB, "fr", { sensitivity: "base" });
        }
        if (Afavorite) {
          return -1;
        }
        if (Bfavorite) {
          return 1;
        }
      });
    },
    async addRoleToFavorite(role) {
      const my = this;

      if (
        !this.sessionUser ||
        this.sessionUser.roles[0] === "ROLE_RESEARCH" ||
        this.sessionUser.roles[0] === "ROLE_MARKETING"
      ) {
        return;
      }

      const segmentationFavoriteRolesRef = firestoreDB
        .collection(`favorite_roles_${process.env.ENV_SHORTNAME}`)
        .doc(my.data.segmentation_id);

      const segmentationFavoriteRolesDoc =
        await segmentationFavoriteRolesRef.get();

      if (this.isFavoriteRole(role)) {
        this.deleteFavoriteRole(segmentationFavoriteRolesRef, role);
      } else if (!segmentationFavoriteRolesDoc.exists) {
        this.createFavoriteRole(segmentationFavoriteRolesRef, role);
      } else {
        this.updateFavoriteRole(segmentationFavoriteRolesRef, role);
      }
    },
    deleteFavoriteRole(segmentationFavoriteRolesRef, role) {
      const my = this;
      segmentationFavoriteRolesRef
        .update({
          favorite_role: firebase.firestore.FieldValue.arrayRemove(role),
        })
        .then(() => {
          console.log("Document successfully deleted!");
          my.getFavoriteRole(segmentationFavoriteRolesRef);
        })
        .catch((error) => {
          console.error("Error updating document :( ", error);
        });
    },
    updateFavoriteRole(segmentationFavoriteRolesRef, role) {
      const my = this;
      segmentationFavoriteRolesRef
        .update({
          favorite_role: firebase.firestore.FieldValue.arrayUnion(role),
        })
        .then(() => {
          console.log("Document successfully updated!");
          my.getFavoriteRole(segmentationFavoriteRolesRef);
        })
        .catch((error) => {
          console.error("Error updating document :( ", error);
        });
    },
    createFavoriteRole(segmentationFavoriteRolesRef, role) {
      const my = this;
      segmentationFavoriteRolesRef
        .set({
          favorite_role: [role],
        })
        .then(() => {
          console.log("Document successfully written!");
          my.getFavoriteRole(segmentationFavoriteRolesRef);
        })
        .catch((error) => {
          console.error("Error writing document :( ", error);
        });
    },
    getFavoriteRole(segmentationFavoriteRolesRef) {
      const my = this;
      segmentationFavoriteRolesRef.get().then((doc) => {
        if (doc.exists) {
          my.segmentationFavoriteRoles = doc.data().favorite_role;
        }
      });
    },
    isFavoriteRole(role) {
      if (this.segmentationFavoriteRoles.indexOf(role) !== -1) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.field === "productRoles" || this.field === "patentRoles") {
      const segmentationFavoriteRolesRef = firestoreDB
        .collection(`favorite_roles_${process.env.ENV_SHORTNAME}`)
        .doc(this.data.segmentation_id);

      this.getFavoriteRole(segmentationFavoriteRolesRef);
    }
  },
};
</script>

<style>
.kt-datatable {
  padding: 20px 10px;
}
table.sticky th {
  position: sticky;
  top: 0;
  color: #ffffff;
}

.datatable_products > table > thead > tr > th {
  background: #fd397a;
  width: 375px;
  max-width: 375px !important;
}

.datatable_productRoles > table > thead > tr > th {
  background: #ffb822;
  width: 1500px;
}

.datatable_patentRoles > table > thead > tr > th {
  background: #ffb822;
  width: 1500px;
}

.datatable_verbatimConsos > table > thead > tr > th {
  background: #5578eb;
  width: 1500px;
}

.datatable_productLeaders > table > thead > tr > th {
  background: #0abb87;
  width: 375px;
}
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/Segmentations/ExtraInfosRow.vue